





















































import {Component, Vue} from 'vue-property-decorator';
import {traineesClient} from "@/api/clients.context";
import {TraineeProfileModel} from "@/domain/trainees/TraineeProfileModel";

@Component({})

export default class StartSplash extends Vue {

    private busy:boolean = true;

    private trainees: TraineeProfileModel[] | null = [];

    async mounted() {
        this.busy =true;
        const result = await traineesClient.getMyTrainees();
        this.trainees = result;
        this.busy = false;
    }
}

